import { render } from "./CardsRecordings.vue?vue&type=template&id=586b4e7e&scoped=true&ts=true"
import script from "./CardsRecordings.vue?vue&type=script&lang=ts"
export * from "./CardsRecordings.vue?vue&type=script&lang=ts"

import "./CardsRecordings.vue?vue&type=style&index=0&id=586b4e7e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-586b4e7e"]])

export default __exports__